import { useEffect, useState } from 'react';

const ProtectedRoute = ({ children }) => {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('aurora_token');
    if (!token) {
      window.location.href = 'http://localhost:3001/login';
    } else {
      setChecking(false);
    }
  }, []);

  if (checking) return null;

  return children;
};

export default ProtectedRoute;